import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import classNames from 'clsx';
import {SvgIcon} from '../icons/svgIcon';
import {Icons} from '../icons/icons';
import './facetFilterWidget.scss';
import {Keyname} from '../utils/utils';

type FacetFilterWidgetProps = {
    filter: string;
    setFilter: (newFilter: string) => void;
    title: string;
};

export const FacetFilterWidget = React.memo(({filter, setFilter, title}: FacetFilterWidgetProps) => {
    const [expanded, setExpanded] = useState(!!filter);
    const filterRef = useRef<HTMLInputElement | null>(null);
    const {t} = useTranslation();

    useEffect(() => {
        if (expanded) {
            filterRef.current?.focus();
        } else {
            setFilter('');
        }
    }, [expanded, setFilter]);

    const onChange = (e) => {
        setFilter(e.target.value);
    };

    const handleKeyDown = (e) => {
        if (e.key === Keyname.ESCAPE) {
            setExpanded(false);
            setFilter('');
            e.stopPropagation();
        }
    };

    const onExpand = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        setExpanded(!expanded);
        e.stopPropagation();
    };

    return (
        <div className={classNames('hibu-facet-filter-widget', expanded ? 'expanded' : 'collapsed')}>
            <input
                ref={filterRef}
                onChange={onChange}
                placeholder={`${t('search.label.placeholder')} ${title}`}
                value={filter}
                onClick={(e) => e.stopPropagation()}
                onKeyDown={handleKeyDown}
            />
            <SvgIcon
                className={filter ? 'clear' : 'search'}
                icon={filter ? Icons.X : Icons.SEARCH}
                onClick={onExpand}
                alt={filter ? t('general.clear') : t('search.label.placeholder') + ' ' + title}
            />
        </div>
    );
});
